import { jsx as _jsx } from "react/jsx-runtime";
export default function ArrowLeft(_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b;
    return (_jsx("svg", { width: "12", height: "12", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M3.21675 6.66669L6.95008 10.4L6.00008 11.3334L0.666748 6.00002L6.00008 0.666687L6.95008 1.60002L3.21675 5.33335H11.3334V6.66669H3.21675Z", fill: disabled ? "#DADADA" : "#5F6368" }) }));
}
